module.exports = __webpack_public_path__ + "img/snow_fall_00002.237b3925.png";